import { z } from 'zod';
import { BasePinComponentSchema, BasePinComponentSettingsSchema } from './base-pin-component';

export const AnswerAreaPinComponentPinThemeSettingsSchema = z.object({
  backgroundColor: z.string().min(1).optional(),
  transparency: z.number().optional(),
});
export type AnswerAreaPinComponentPinThemeSettings = z.infer<typeof AnswerAreaPinComponentPinThemeSettingsSchema>;

const AnswerAreaSettingsSchema = BasePinComponentSettingsSchema.extend(
  AnswerAreaPinComponentPinThemeSettingsSchema.shape
);
export type AnswerAreaSettings = z.infer<typeof AnswerAreaSettingsSchema>;

export const AnswerAreaPinComponentTypeSchema = z.literal('ANSWER_AREA');

export const AnswerAreaPinComponentSchema = BasePinComponentSchema.extend(
  z.object({
    type: AnswerAreaPinComponentTypeSchema,
    settings: AnswerAreaSettingsSchema,
  }).shape
);
